// extracted by mini-css-extract-plugin
export default {"modal-header":"style_modal-header__6XyIE","modal-header__title":"style_modal-header__title__SOR6j","modal-header__close-button":"style_modal-header__close-button__jMbsa"};